export default {
  SET_FIELD_APPLICATIONS_INSTANCES: 'setFieldApplicationsIntances',
  SET_SELECTED_TENANT: 'setSelectedTenant',
  SET_TENANTS: 'setTenants',
  SET_INACTIVE_FILTER_VAL: 'setInactiveFilterVal',
  SET_SELECTED_TENANT_QUOTA: 'setSelectedTenantQuota',
}